module.exports = __webpack_public_path__ + "img/2.69e013fd.png";